<template>
  <div class="faka-container">
    <!-- 顶部搜索区域 -->
    <el-card shadow="hover" class="search-card">
      <el-form :model="searchParams" :inline="true">
        <el-form-item label="商品名称">
          <el-input v-model="searchParams.name" placeholder="搜索商品名称" clearable/>
        </el-form-item>
        
        <el-form-item label="商品分类">
          <el-select v-model="searchParams.categoryId" placeholder="请选择分类" clearable>
            <el-option 
              v-for="item in categoryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="库存状态">
          <el-select v-model="searchParams.stockStatus" placeholder="请选择状态" clearable>
            <el-option 
              v-for="item in stockOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="onSearch">搜索</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 商品列表 -->
    <div class="product-list">
      <el-row :gutter="20">
        <el-col :span="6" v-for="item in products" :key="item.id">
          <el-card shadow="hover" class="product-card">
            <router-link :to="'/home/creation/faka-detail/'+item.id">
              <div class="product-cover">
                <el-image 
                  :src="item.images && item.images.split(',')[0]"
                  fit="cover"
                  class="cover-image"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div class="product-status" v-if="item.stock <= 0">
                  <span>已售罄</span>
                </div>
              </div>
            </router-link>

            <div class="product-content">
              <h3 class="product-title" :title="item.name">{{item.name}}</h3>
              
              <div class="product-meta">
                <div class="price-box">
                  <span class="price-label">售价</span>
                  <span class="price">¥{{item.price}}</span>
                </div>
                <div class="stock-box">
                  <span class="stock-label">库存</span>
                  <span class="stock" :class="{'stock-empty': item.stock <= 0}">
                    {{item.stock}}
                  </span>
                </div>
              </div>
              
              <div class="product-footer">
                <span class="sales">销量 {{item.soldCount || 0}}</span>
                <div class="action-btns">
                  <el-tooltip content="分享" placement="top">
                    <el-button type="text" @click.stop="shareProduct(item)">
                      <i class="el-icon-share"></i>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip content="卡密管理" placement="top">
                    <el-button type="text" @click.stop="manageCards(item)">
                      <i class="el-icon-tickets"></i>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip content="编辑" placement="top">
                    <el-button type="text" @click.stop="editProduct(item)">
                      <i class="el-icon-edit"></i>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip content="删除" placement="top">
                    <el-button type="text" @click.stop="deleteProduct(item)">
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 分页 -->
      <el-pagination
        v-if="total > 0"
        class="pagination"
        background
        @current-change="handleCurrentChange"
        :current-page.sync="searchParams.pageNum"
        :page-size="searchParams.pageSize"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>

    <!-- 新增按钮 -->
    <div class="floating-btn">
      <el-button 
        type="primary" 
        class="add-btn"
        @click="goToAdd"
      >
        <i class="el-icon-plus"></i>
        <span>新增商品</span>
      </el-button>
    </div>

    <!-- 卡密管理弹窗 -->
    <el-dialog
      title="卡密管理"
      :visible.sync="cardDialogVisible"
      width="800px"
      class="card-dialog"
    >
      <div class="card-manage">
        <div class="manage-header">
          <div class="header-left">
            <span class="stock-info">当前库存: {{currentProduct.stock || 0}}</span>
            <el-button 
              type="primary" 
              size="small"
              @click="showAddCardDialog"
            >添加卡密</el-button>
            <el-upload
              class="batch-upload"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              :on-success="handleBatchUpload"
              accept=".txt,.csv"
            >
            </el-upload>
          </div>
          
          <div class="header-right">
            <el-input
              v-model="cardSearch"
              placeholder="搜索卡密"
              prefix-icon="el-icon-search"
              clearable
            />
          </div>
        </div>

        <!-- 卡密列表 -->
        <el-table 
          :data="filteredCards"
          border
          stripe
          style="width: 100%"
          v-loading="loading"
          height="450"
          :header-cell-style="{background:'#f5f7fa'}"
        >
          <el-table-column 
            label="卡密内容" 
            prop="content"
            show-overflow-tooltip
          />
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'Y' ? 'success' : 'info'">
                {{scope.row.status === 'N' ? '未售' : '已售'}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column 
            label="创建时间" 
            prop="createTime" 
            width="180"
            align="center"
          />
          <el-table-column
              label="售出时间"
              prop="useTime"
              width="180"
              align="center"
          />
          <el-table-column 
            label="操作" 
            width="100" 
            fixed="right"
            align="center"
          >
            <template slot-scope="scope">
              <el-button 
                type="text"
                size="small"
                @click="deleteCard(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 添加卡密弹窗 -->
    <el-dialog
      title="添加卡密"
      :visible.sync="addCardVisible"
      width="500px"
    >
      <el-form :model="newCard" ref="cardForm" :rules="cardRules">
        <el-form-item label="卡密内容" prop="content">
          <el-input 
            type="textarea"
            v-model="newCard.content"
            :rows="4"
            placeholder="请输入卡密内容,一行一个"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addCardVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCard">确定</el-button>
      </div>
    </el-dialog>

    <!-- 分享弹窗 -->
    <el-dialog
      title="分享商品"
      :visible.sync="shareDialogVisible"
      width="400px"
      center
    >
      <div class="share-dialog">
        <div class="share-link">
          <div class="link-label">商品链接</div>
          <el-input
            v-model="shareUrl"
            readonly
            class="link-input"
          >
            <template slot="append">
              <el-button type="primary" @click="copyShareUrl">复制</el-button>
            </template>
          </el-input>
        </div>
        
        <div class="share-qrcode">
          <div class="qrcode-label">扫码分享</div>
          <div ref="qrCodeDiv"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import VueClipboard from 'vue-clipboard2'
import Vue from 'vue'

Vue.use(VueClipboard)

export default {
  data() {
    return {
      searchParams: {
        name: '',
        categoryId: '',
        stockStatus: '',
        pageNum: 1,
        pageSize: 12
      },
      categoryOptions: [
        { label: '全部分类', value: '' },
        { label: '游戏充值', value: '1' },
        { label: '会员账号', value: '2' },
        { label: '激活码', value: '3' },
        { label: '其他卡密', value: '4' }
      ],
      stockOptions: [
        { label: '全部状态', value: '' },
        { label: '有库存', value: '1' },
        { label: '无库存', value: '2' }
      ],
      products: [],
      total: 0,
      loading: false,
      cardDialogVisible: false,
      addCardVisible: false,
      currentProduct: {},
      cardSearch: '',
      newCard: {
        content: ''
      },
      cardRules: {
        content: [
          { required: true, message: '请输入卡密内容', trigger: 'blur' }
        ]
      },
      uploadUrl: process.env.VUE_APP_BASE_API + '/klgeek/faka/cards/import',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      cardList: [],
      shareDialogVisible: false,
      shareUrl: '',
      qrCodeDiv: null
    }
  },
  
  computed: {
    filteredCards() {
      if(!this.cardSearch) {
        return this.cardList || []
      }
      return (this.cardList || []).filter(card => 
        card.content.toLowerCase().includes(this.cardSearch.toLowerCase())
      )
    }
  },
  
  methods: {
    async loadProducts() {
      this.loading = true
      try {
        const res = await this.$http2({
          url: '/klgeek/fakaProduct/list',
          method: 'get',
          params: this.searchParams
        })
        this.products = res.rows || []
        this.total = res.total || 0
      } catch(e) {
        console.error(e)
        this.$message.error('加载商品列表失败')
      } finally {
        this.loading = false
      }
    },

    async deleteProduct(item) {
      try {
        await this.$http2({
          url: `/klgeek/fakaProduct/${item.id}`,
          method: 'delete'
        })
        this.$message.success('删除成功')
        this.loadProducts()
      } catch(e) {
        console.error(e)
        this.$message.error('删除失败')
      }
    },
    
    onSearch() {
      this.searchParams.pageNum = 1
      this.loadProducts()
    },
    
    onReset() {
      this.searchParams = {
        name: '',
        categoryId: '',
        stockStatus: '',
        pageNum: 1,
        pageSize: 12
      }
      this.loadProducts()
    },

    handleCurrentChange(val) {
      this.searchParams.pageNum = val
      this.loadProducts()
    },
    
    goDetail(item) {
      this.$router.push(`/home/creation/faka-detail/${item.id}`)
    },
    
    goToAdd() {
      this.$router.push('/home/creation/faka-add')
    },
    
    editProduct(item) {
      this.$router.push(`/home/creation/faka-add?id=${item.id}`)
    },

    async manageCards(product) {
      this.currentProduct = product
      this.cardDialogVisible = true
      await this.loadProductCards(product.id)
    },

    async loadProductCards(productId) {
      this.loading = true
      try {
        const res = await this.$http2({
          url: `/klgeek/fakaCard/list?productId=${productId}`,
          method: 'get'
        })
        this.cardList = res.rows || []
      } catch(e) {
        console.error(e)
        this.$message.error('加载卡密列表失败')
      } finally {
        this.loading = false
      }
    },

    showAddCardDialog() {
      this.addCardVisible = true
      this.newCard.content = ''
    },

    async submitCard() {
      this.$refs.cardForm.validate(async valid => {
        if(valid) {
          try {
            await this.$http2({
              url: '/klgeek/fakaCard',
              method: 'post',
              data: {
                productId: this.currentProduct.id,
                contents: this.newCard.content
              }
            })
            this.$message.success('添加成功')
            this.addCardVisible = false
            this.loadProducts();
            await this.loadProductCards(this.currentProduct.id)
          } catch(e) {
            this.$message.error('添加失败')
          }
        }
      })
    },

    async deleteCard(card) {
      try {
        await this.$confirm('确认删除该卡密?', '提示', {
          type: 'warning'
        })
        await this.$http2({
          url: `/klgeek/fakaCard/${card.id}`,
          method: 'delete'
        })
        this.$message.success('删除成功')
        this.onReset();
        await this.loadProductCards(this.currentProduct.id)

      } catch(e) {
        if(e !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    },

    handleBatchUpload(res) {
      if(res.success) {
        this.$message.success('导入成功')
        this.loadProductCards(this.currentProduct.id)
      } else {
        this.$message.error('导入失败')
      }
    },

    shareProduct(item) {
      // 生成分享链接
      this.shareUrl = process.env.VUE_APP_SHARE_BASE+ `/#/fakaDetail/${item.id}`
      
      // 生成二维码
      this.$nextTick(() => {
        // 清空之前的二维码
        this.$refs.qrCodeDiv.innerHTML = ''
        
        new QRCode(this.$refs.qrCodeDiv, {
          text: this.shareUrl,
          width: 128,
          height: 128,
          colorDark : "#000000",
          colorLight : "#ffffff",
          correctLevel : QRCode.CorrectLevel.H
        })
      })
      
      this.shareDialogVisible = true
    },

    copyShareUrl() {
      this.$copyText(this.shareUrl).then(() => {
        this.$message.success('复制成功')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    }
  },
  
  mounted() {
    this.loadProducts()
  }
}
</script>

<style lang="scss" scoped>
.faka-container {
  padding: 20px;
  
  .search-card {
    margin-bottom: 20px;
  }
  
  .product-list {
    margin-bottom: 40px;
    
    .product-card {
      margin-bottom: 20px;
      border: none;
      transition: all 0.3s;
      
      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 20px rgba(0,0,0,0.1);
      }
      
      .product-cover {
        position: relative;
        height: 220px;
        overflow: hidden;
        border-radius: 8px 8px 0 0;
        
        .cover-image {
          width: 100%;
          height: 100%;
          
          :deep(.image-slot) {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            background: #f5f7fa;
            color: #909399;
            font-size: 30px;
          }
        }
        
        .product-status {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          
          span {
            color: #fff;
            font-size: 18px;
            padding: 8px 20px;
            border: 2px solid #fff;
            border-radius: 20px;
          }
        }
      }
      
      .product-content {
        padding: 15px;
        
        .product-title {
          font-size: 16px;
          margin: 0 0 15px;
          line-height: 1.4;
          height: 44px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          color: #303133;
        }
        
        .product-meta {
          display: flex;
          justify-content: space-between;
          margin-bottom: 15px;
          padding: 10px;
          background: #f8f9fa;
          border-radius: 6px;
          
          .price-box, .stock-box {
            display: flex;
            flex-direction: column;
            
            .price-label, .stock-label {
              font-size: 12px;
              color: #909399;
              margin-bottom: 4px;
            }
            
            .price {
              color: #f56c6c;
              font-size: 20px;
              font-weight: bold;
            }
            
            .stock {
              font-size: 16px;
              color: #67c23a;
              font-weight: 500;
              
              &.stock-empty {
                color: #f56c6c;
              }
            }
          }
        }
        
        .product-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          
          .sales {
            font-size: 13px;
            color: #909399;
          }
          
          .action-btns {
            .el-button {
              padding: 0 8px;
              font-size: 16px;
              
              &:hover {
                color: #409EFF;
              }
            }
          }
        }
      }
    }
    
    .pagination {
      margin-top: 30px;
      text-align: center;
    }
  }
  
  .floating-btn {
    position: fixed;
    right: 40px;
    bottom: 40px;
    z-index: 999;
    
    .add-btn {
      padding: 12px 24px;
      border-radius: 25px;
      font-size: 16px;
      box-shadow: 0 4px 12px rgba(64,158,255,0.3);
      
      i {
        margin-right: 6px;
      }
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(64,158,255,0.4);
      }
    }
  }

  .card-manage {
    .manage-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      
      .header-left {
        display: flex;
        align-items: center;
        
        .stock-info {
          margin-right: 20px;
          font-size: 14px;
          color: #606266;
        }
        
        .batch-upload {
          margin-left: 10px;
        }
      }
      
      .header-right {
        width: 200px;
      }
    }

    :deep(.el-table) {
      .el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      
      .el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: #dcdfe6;
      }
      
      .el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 3px;
        background: #f5f7fa;
      }

      .el-table__row {
        &:hover {
          td {
            background-color: #f5f7fa !important;
          }
        }
      }

      .cell {
        .el-button {
          padding: 4px 8px;
        }
      }
    }
  }

  .share-dialog {
    .share-link {
      margin-bottom: 20px;
      
      .link-label {
        font-size: 14px;
        color: #606266;
        margin-bottom: 10px;
      }
      
      .link-input {
        :deep(.el-input-group__append) {
          padding: 0;
          
          .el-button {
            margin: 0;
            border: none;
            border-radius: 0;
          }
        }
      }
    }
    
    .share-qrcode {
      text-align: center;
      
      .qrcode-label {
        font-size: 14px;
        color: #606266;
        margin-bottom: 10px;
      }
      
      :deep(img) {
        margin: 0 auto;
      }
    }
  }

  :deep(.card-dialog) {
    .el-dialog__body {
      padding: 20px;
    }
  }
}
</style> 